import { render, staticRenderFns } from "./ChartTwitchPreview.vue?vue&type=template&id=3df6226e&"
import script from "./ChartTwitchPreview.vue?vue&type=script&lang=js&"
export * from "./ChartTwitchPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports